export enum ServiceStatusEnum {
    OPEN = 'OPEN',
    INPROGRESS = 'INPROGRESS',
    COMPLETE = 'COMPLETED'
}